import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { media } from 'context';
import { Animate, Layout, Text } from 'ds';
import { SERVICES_REQUEST_PATH } from 'routes/paths';

import { ReactComponent as AiAssistantIcon } from 'ds/ai-assistant.svg';

import './ServicesRequest.scss';

interface Props {}

const ServicesRequestCongrats: React.FC<Props> = () => {
  const { isMobile } = useContext(media);

  const history = useHistory();
  useEffect(() => {
    const id = setTimeout(() => {
      history.push(`${SERVICES_REQUEST_PATH}/set-up`);
    }, 1_500);

    return () => clearTimeout(id);
  }, [history]);

  return (
    <Layout
      background="linear-gradient(86deg, rgba(0, 120, 255, 0.05) 0%, rgba(142, 95, 244, 0.05) 100%)"
      height="100vh"
      width="100vw"
      align="center"
      paddingX={isMobile ? 24 : 0}
    >
      <Layout justify="center" equalWidth>
        <Layout position="relative" maxWidth={568} flexGrow={1} align="center">
          <Layout align="center" gap={16}>
            <AiAssistantIcon style={{ flexShrink: 0 }} width={72} height={72} />
            <Animate duration={300} flexShrink={0}>
              <Text size={isMobile ? 'headline-md' : 'display-sm'} color="purple-gradient" wrap={isMobile}>
                Congrats on your new <br />
                office!
              </Text>
            </Animate>
          </Layout>
        </Layout>
      </Layout>
      <Layout equalWidth></Layout>
    </Layout>
  );
};

export default ServicesRequestCongrats;
